import React from "react";
import lazyPage from "../../../../../common/helpers/lazyPage";

import Loader from "../../../../components/Loader";

export default lazyPage(
    "src/front/pages/plan/Menu/PublishModal/PublishModal.tsx",
    () => import("./PublishModal"),
    <Loader margin="auto" />,
);
